import localeData from '../helpers/login.lang'
import {isModeOneOf, checkPasswordPolicyViolation} from '../login.helper'
import {loginModes, twoFactorCodePrefix} from '../helpers/login.data'

const language = 'en'
const locale = localeData[language]
const {createNewPassword, renewExpiredPassword} = loginModes

export const validateUsernameInput = ({isUsernameDirty}) => [
  {
    criteria: (value => isUsernameDirty && value.length === 0),
    message: locale.usernameIsRequired()
  }
]

export const validatePasswordInput = ({password, isPasswordDirty, passwordPolicy, mode, wasExistingPasswordUsed}) => [
  {
    criteria: (value => isPasswordDirty && value.length === 0),
    message: locale.passwordIsRequired()
  },
  {
    criteria: () => (isPasswordDirty && isModeOneOf({mode, modes: [createNewPassword, renewExpiredPassword]}) && checkPasswordPolicyViolation({
      password,
      passwordPolicy
    })),
    message: checkPasswordPolicyViolation({
      password,
      passwordPolicy
    }) || ''
  },
  {
    criteria: () => (isPasswordDirty && isModeOneOf({mode, modes: [createNewPassword, renewExpiredPassword]}) && wasExistingPasswordUsed),
    message: locale.existingPasswordUsed()
  }
]

export const validateConfirmPasswordInput = ({password, confirmPassword, isConfirmPasswordDirty, passwordPolicy}) => [
  {
    criteria: (() => password.length > 0 && isConfirmPasswordDirty && (checkPasswordPolicyViolation({
      password,
      passwordPolicy
    }) === false) && (confirmPassword !== password)),
    message: locale.passwordsAreNotTheSame()
  }
]

export const validateTFAInput = ({hasAuthFailed, secretCode, isSecretCodeDirty}) => [
  {
    criteria: () => hasAuthFailed,
    message: locale.authWithTwoFactorFailed()
  },
  {
    criteria: (() => isSecretCodeDirty && !(secretCode.startsWith(twoFactorCodePrefix) && (secretCode.length > twoFactorCodePrefix.length))),
    message: locale.secretCodeIsRequired()
  }
]

export const validateAuditInput = ({auditMessage, isAuditMessageDirty}) => [
  {
    criteria: () => isAuditMessageDirty && !auditMessage,
    message: locale.auditWarning()
  }
]

